import React, { FunctionComponent } from 'react';

import { ProtectedContentWithoutCompletedRequests } from 'app/components/protected-content-without-completed-requests';
import { userPartnersRequest } from 'app/pages/order/hooks/user-partners-request';
import { useAccountRequest } from 'app/pages/order/hooks/use-accounts-request';

import { ChooseAccountContent } from './choose-account-content';

const ChooseAccountPage: FunctionComponent = () => {
    const accountsRequest = useAccountRequest();
    const partnersRequest = userPartnersRequest();

    return (
        <ProtectedContentWithoutCompletedRequests requests={[accountsRequest, partnersRequest]}>
            <ChooseAccountContent />
        </ProtectedContentWithoutCompletedRequests>
    );
};

export { ChooseAccountPage };
